import { DataMessage } from "amazon-chime-sdk-js";
import { BREAKOUT, Room } from "../types";
import { fromOrganizer, state } from "../state";
import { API } from "../../../utils/AxiosInstance";

export function addOrderUpdate(room: Room) {
    const index = state.breakoutRooms.findIndex(
        (x) => String(x.meeting_id) === String(room.meeting_id)
    );

    if (index === -1) {
        state.breakoutRooms = [...state.breakoutRooms, room];
    }

    state.breakoutRooms[index] = room;
}

export async function fetchBreakoutRooms() {
    if (!state.breakout.lastFetched) {
        state.breakout.isLoading = true;
    }

    try {
        state.breakout.isFetching = true;
        const { data } = await API.get<Room[]>(
            `/meetings/${state.meetingId}/breakout_rooms`
        );
        state.breakout.rooms = data;
        state.breakout.isFetching = false;
        state.breakout.isLoading = false;
        state.breakout.lastFetched = Date.now();
    } catch {
        state.breakout.isFetching = false;
        state.breakout.isLoading = false;
    }
}

export async function addRoom(roomCount: number) {
    try {
        await API.post(`/meetings/${state.mainMeetingId}/meeting_rooms`, {
            room_count: roomCount,
        });
        void fetchBreakoutRooms();
    } catch {
        // ignore
    }
}

export async function openBreakoutRoom(roomId: string) {
    try {
        await API.post(
            `/meetings/${state.meetingId}/meeting_rooms/${roomId}/open_rooms`,
            { room_ids: [roomId] }
        );
        const room = state.breakout.rooms?.find((x) => x.id === roomId);
        if (!room) return;

        const userIds = room.users.map((x) => x.id);

        state.audioVideo?.realtimeSendDataMessage(BREAKOUT, {
            roomId: room.meeting_id,
            userIds,
        });
        void fetchBreakoutRooms();
    } catch {
        // ignore
    }
}

export async function closeBreakoutRoom(roomId: string) {
    try {
        await API.post(
            `/meetings/${state.meetingId}/meeting_rooms/${roomId}/close_rooms`,
            { room_ids: [roomId] }
        );
        void fetchBreakoutRooms();
    } catch {
        // ignore
    }
}

export async function addUsersToBreakoutRoom(
    roomId: string,
    userIds: string[]
) {
    try {
        await API.post(
            `/meetings/${state.meetingId}/meeting_rooms/${roomId}/add_users`,
            { user_ids: userIds }
        );
        void fetchBreakoutRooms();
    } catch {
        // ignore
    }
}

export async function removeUserFromBreakoutRoom(
    roomId: string,
    userId: string
) {
    try {
        await API.post(
            `/meetings/${state.meetingId}/meeting_rooms/${roomId}/remove_user`,
            { user_id: userId }
        );
        void fetchBreakoutRooms();
    } catch {
        // ignore
    }
}

export function joinRoom(roomId: string, autoJoin: boolean) {
    state.breakout.autoJoin = autoJoin;
    state.breakout.joinMeetingId = roomId;
}

export function breakoutCallback(msg: DataMessage) {
    if (!fromOrganizer(msg.senderExternalUserId)) return;

    const json = msg.json() as { roomId: string; userIds?: string[] };
    const attendee = state.roster[state.currentUser.attendeeId];
    if (
        attendee.userId &&
        json.userIds &&
        json.userIds.includes(attendee.userId)
    ) {
        joinRoom(json.roomId, true);
    }
}
